import { render, staticRenderFns } from "./tagSlide.vue?vue&type=template&id=0e2c0d62&scoped=true"
import script from "./tagSlide.vue?vue&type=script&lang=ts"
export * from "./tagSlide.vue?vue&type=script&lang=ts"
import style0 from "./tagSlide.vue?vue&type=style&index=0&id=0e2c0d62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2c0d62",
  null
  
)

/* custom blocks */
import block0 from "./tagSlide.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports